var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-client-table", {
    staticClass: "vue-custom-table no-pagination",
    attrs: { data: _vm.data, columns: _vm.columns, options: _vm.options },
    scopedSlots: _vm._u(
      [
        {
          key: "h__personalInformation",
          fn: function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "request-package.requestApplicationDetails.personalInformation"
                    )
                  ) +
                  "\n    "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.top.html",
                    value: _vm.applicationCustomizationRulesText,
                    expression: "applicationCustomizationRulesText",
                    modifiers: { top: true, html: true },
                  },
                ],
                staticClass: "text-grey ml-1",
                attrs: { name: "info-circle" },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "h__property",
          fn: function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("application-form.property")) +
                  "\n    "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.top.html",
                    value: _vm.applicationCustomizationRulesText,
                    expression: "applicationCustomizationRulesText",
                    modifiers: { top: true, html: true },
                  },
                ],
                staticClass: "text-grey ml-1",
                attrs: { name: "info-circle" },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "h__mortgageDetails",
          fn: function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t("application.pages.navigation-tabs.mortgage-details")
                  ) +
                  "\n    "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.top.html",
                    value: _vm.applicationCustomizationRulesText,
                    expression: "applicationCustomizationRulesText",
                    modifiers: { top: true, html: true },
                  },
                ],
                staticClass: "text-grey ml-1",
                attrs: { name: "info-circle" },
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "applicantFullName",
          fn: function (ref) {
            var row = ref.row
            return [
              _vm._t(
                "applicantFullName",
                function () {
                  return [
                    _vm._v(
                      "\n      " + _vm._s(row.applicantFullName) + "\n    "
                    ),
                  ]
                },
                { row: row }
              ),
            ]
          },
        },
        {
          key: "property",
          fn: function (ref) {
            var row = ref.row
            return [
              _c("div", { staticClass: "pretty p-round p-default" }, [
                _c("input", {
                  attrs: {
                    id: _vm.labelValue1,
                    type: "radio",
                    name: "select-property-" + row.applicantIndex,
                  },
                  domProps: {
                    checked: _vm.selectedProperty === row.applicantIndex,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleChangeApplicationDetails(
                        row.applicantIndex,
                        "localSelectedProperty"
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "state p-primary" }, [
                  _c(
                    "label",
                    {
                      staticClass: "hidden-text",
                      attrs: { for: _vm.labelValue1 },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.words.select")))]
                  ),
                ]),
              ]),
            ]
          },
        },
        {
          key: "mortgageDetails",
          fn: function (ref) {
            var row = ref.row
            return [
              _c("div", { staticClass: "pretty p-round p-default" }, [
                _c("input", {
                  attrs: {
                    id: _vm.labelValue2,
                    type: "radio",
                    name: "select-mortgage-details-" + row.applicantIndex,
                  },
                  domProps: {
                    checked: _vm.selectedMortgageDetails === row.applicantIndex,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleChangeApplicationDetails(
                        row.applicantIndex,
                        "localSelectedMortgageDetails"
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "state p-primary" }, [
                  _c(
                    "label",
                    {
                      staticClass: "hidden-text",
                      attrs: { for: _vm.labelValue2 },
                    },
                    [_vm._v(_vm._s(_vm.$t("global.words.select")))]
                  ),
                ]),
              ]),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }